export default "__VITE_ASSET__B3jN1M3s__"